import "./scss/CTT.scss";
import "./css/leaflet.css";

import WooCommerce from "./js/CTT-woo-commerce.js";
import CTTWidget from "./js/CTT-widget";

/**
 * Class CTT depends on jQuery.
 * Check if we are meant to append a map
 *
 * Platform dependent functions marked with   * @platformDependent
 */
class CTT {
  constructor(ajax_url) {
    console.log("CTT CONSTRUCT");
    this.markers = []; //pickup {lat, lng}
    this.isMapLoaded = false;
    this.gmaps_key =
      typeof CTT_maps_key == "undefined" ? "" : CTT_maps_key;
    this.openMapMarkerIcons = {};
    this.ajax_url = ajax_url; // platform dependent

    // ✅ Track if scripts are preloading
    this.scriptsPreloaded = false;
    this.addressPreGeocoded = false;

    this.platform = new WooCommerce(this.ajax_url);

    this.platform.isCheckout();
    this.init();
  }

  init() {
    console.log("Entered init");
    this.CTTWidget = new CTTWidget({
      host: "https://CTT.me",
      address: this.platform.getShippingData().Address,
      labels: {},
      mapParentContainer: "body",
      buttonParentContainer: "body",
      buttonClass: "",
      ajax_url: this.ajax_url,
      carrierId: this.platform.getShippingData().CarrierId,
      onPointSelected: () => {},
      gmapskey:
        typeof CTT_maps_key == "undefined" ? "" : CTT_maps_key,
    });
    this.CTTWidget.init();

    // ✅ Preload map resources in the background
    this.preloadMapResources();

    console.log("Finished init");
  }

  /**
   * ✅ NEW: Preload map scripts and geocode address in background
   */
  preloadMapResources() {
    console.log("🚀 Preloading map resources...");

    setTimeout(() => {
      // ✅ 1. Preload map scripts
      if (this.CTTWidget.mapinterface && !this.scriptsPreloaded) {
        console.log("📦 Preloading map scripts");
        this.scriptsPreloaded = true;

        if (jQuery("#sw").length === 0) {
          this.CTTWidget.addMapHtml();
        }
      }

      // ❌ DISABLE ADDRESS PRE-GEOCODING - causes rate limit issues
      // Only geocode when user actually opens the map
      /*
    if (!this.addressPreGeocoded && this.CTTWidget.options.address) {
      const address = this.CTTWidget.options.address;

      if (address.City && address.Country) {
        console.log("🌍 Pre-geocoding address:", address.City, address.Country);
        this.addressPreGeocoded = true;

        this.CTTWidget.geocodeAddress(address, (geo) => {
          if (geo && geo.length && geo[0].lat) {
            console.log("✅ Address pre-geocoded:", geo[0].lat, geo[0].lng);
            this.CTTWidget.options.address.Lat = geo[0].lat;
            this.CTTWidget.options.address.Long = geo[0].lng;
            this.preFetchPickupPoints();
          }
        });
      }
    }
    */
    }, 2000);
  }
  /**
   * ✅ NEW: Pre-fetch pickup points in background
   */
  preFetchPickupPoints() {
    // Only if we have carrier ID and geocoded address
    if (
      !this.CTTWidget.carrier_id ||
      !this.CTTWidget.options.address.Lat
    ) {
      console.log("⏭️ Skipping pre-fetch - missing carrier or coordinates");
      return;
    }

    console.log("📍 Pre-fetching pickup points...");

    const req = {
      Address: this.CTTWidget.options.address,
      CarrierId: this.CTTWidget.carrier_id,
      action: "CTT_pickup_locations",
    };

    jQuery
      .getJSON(this.ajax_url, req, (data) => {
        if (data && data.Point && data.Point.length > 0) {
          console.log("✅ Pickup points pre-fetched:", data.Point.length);

          // ✅ Cache the results
          const cacheKey = this.CTTWidget.hashLatLng({
            lat: this.CTTWidget.options.address.Lat,
            lng: this.CTTWidget.options.address.Long,
          });

          this.CTTWidget.cacheResults[cacheKey] = data;
          console.log("💾 Cached pickup points for instant display");
        }
      })
      .fail(() => {
        console.log("⚠️ Pre-fetch failed (not critical)");
      });
  }

  getPickupLocations(evt) {
    console.log("Choose Pickup Location");

    // ✅ Show loader immediately (no delay)
    const loaderHtml = `
        <div class="CTT-loader-btn" style="position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; background-color: rgba(0, 0, 0, 0.7) !important; z-index: 999999 !important; display: flex !important; justify-content: center !important; align-items: center !important;">
            <div class="loader-squares">
                <div class="loader-square"></div>
                <div class="loader-square"></div>
                <div class="loader-square"></div>
            </div>
        </div>`;

    jQuery("body").append(loaderHtml);

    // ✅ Open map (should be MUCH faster now)
    this.CTTWidget.openMap();
  }
}

jQuery(function () {
  if (typeof woocommerce_params != "undefined") {
    window.CTT = new CTT(woocommerce_params.ajax_url);
  }
});
